import React, { PureComponent } from 'react'
import PropTypes, { array } from 'prop-types';

import {
    View,
    StyleSheet,
} from 'react-native'
import {
    JDTouchable,
    JDText,
    JDRouter,
    JDImage
} from '@jdreact/jdreact-core-lib'

import { pt } from '../../common/utils';

import img from '../../common/img';

export default class Promotion extends PureComponent {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        // promoTypes: 'scale'
    }

    render() {
        const { promoTypes, scaleFn, cardFn, promoDesc, govSubsidy } = this.props
        let index = (promoTypes[0].promoType)
        return (
            promoTypes.length > 0 ? <View style={[st.allList, govSubsidy === "true" ? st.newAllList : ""]}>

                <JDTouchable onPress={() => govSubsidy !== "true" && scaleFn && scaleFn()}  >
                    <View style={st.list}>
                        <View style={st.left}>
                            <View style={[st.v_scale, govSubsidy === "true" ? st.newVScale : ""]}><JDText style={st.scale}>惠</JDText></View>
                            {/* <JDText numberOfLines={1} style={[st.scaleTxt, st.orangeTxt]}>{promoTxt[index].txt}{promoTypes[0].promoPrice/100}元</JDText> */}
                            <JDText numberOfLines={1} style={[st.scaleTxt, govSubsidy === "true" ? st.greenTxt : st.orangeTxt]}>{promoDesc}</JDText>
                        </View>
                        {
                            govSubsidy !== "true" 
                            ? <View style={st.left}>
                                <JDText style={st.r_txt}>{promoTypes.length}个活动</JDText>
                                {
                                    <JDImage style={{width: pt(4), height: pt(10)}} source={img.right}/>
                                }
                            </View>
                            : null
                        }
                    </View>
                </JDTouchable>

                {/* <JDTouchable  onPress={ ()=> cardFn&&cardFn()}  >                
                    <View style={[st.list,st.card]}>
                        <View style={st.left}>
                            <JDText style={[ st.scale, st.blue ]}>卡</JDText>
                            <JDText numberOfLines={1} style={[ st.scaleTxt, st.blueTxt ]}>PLUS会员专享暑期大套餐购买年卡立减优惠</JDText>
                        </View>
                        <View style={st.left}>
                            <JDText style={st.r_txt}>4个活动</JDText>
                            <JDImage source={img.right}></JDImage>
                        </View>
                    </View>
                </JDTouchable> */}

            </View> : null
        );
    }
}

const st = StyleSheet.create({
    allList: {
        padding: pt(5),
        backgroundColor: '#EDF3FF',
    },
    newAllList: {
        backgroundColor: '#F0FAF4',
    },
    list: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        // height: pt(30),
        padding: pt(10),
        alignItems: 'center',
    },
    card: {
        paddingTop: 0
    },
    left: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    r_txt: {
        fontSize: pt(12),
        marginRight: pt(5),
        color: '#666'
    },    
    newRtxt: {
        color: '#0AAD48'
    },
    scale: {
        color: '#fff',
        fontSize: pt(10),
    },
    v_scale: {
        height: pt(15),
        width: pt(14),
        backgroundColor: '#F56A00',
        borderRadius: pt(2),
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: pt(5)
    },
    newVScale: {
        backgroundColor: '#0AAD48'
    },
    greenArrow: {
        width: pt(5),
        height: pt(8),
    },
    scaleTxt: {
        color: '#000',
        width: pt(270),
        fontSize: pt(12)
    },
    orange: {
        backgroundColor: '#F56A00',
    },
    blue: {
        backgroundColor: '#2B84FF',
    },
    orangeTxt: {
        color: '#F56A00',
    },
    greenTxt: {
        color: '#0AAD48',
    },
    blueTxt: {
        color: '#2B84FF',
    },
    right: {

    },
})


module.exports = Promotion;
